import React from 'react';
import { ChevronUp } from 'lucide-react';

export function BackToTopButton({ t }) {
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-50 bg-emerald-500 hover:bg-emerald-600 p-3 rounded-full shadow-lg shadow-emerald-500/25 transition-all"
      title={t('backToTop')}
    >
      <ChevronUp className="w-5 h-5" />
    </button>
  );
}

export default BackToTopButton;
